import {Accordion, AccordionItem} from '@kit';

import React from 'react';

import {Class} from '../../../generated/types';
import {columnTitle, featureTitle, levelFeatures, SPELL_LEVELS_REGEXP} from '../columns';
import {humanJoin} from '../../utils';
import {Link} from '../../../lib/routes';
import {PartialFeature} from '../../feature-view';

import css from './list-view.module.css';

type Props = {
	heroClass: Class;
	features: PartialFeature[];
};

export const ListView: React.FC<Props> = ({heroClass, features}) => {
	return (
		<Accordion>
			{heroClass.rows?.map((columns, index) => {
				const level = (index + 1).toString();
				const cells: Array<{title: string; value: string}> = [];
				const slots: Array<{circle: string; count: number}> = [];

				heroClass.columns.forEach((column, columnIndex) => {
					const value = columns?.[columnIndex] || '';
					if (column === '@Level' || column === '@Features') return;
					if (SPELL_LEVELS_REGEXP.test(column)) {
						if (value && value !== '—') slots.push({circle: column.replace('@', ''), count: parseInt(value) || 0});
						return;
					}
					cells.push({title: columnTitle(column), value: value || '—'});
				});

				const rowFeatures = levelFeatures(features, level);

				return (
					<AccordionItem
						key={level}
						title={`${level}-й уровень`}
						note={rowFeatures.map((feature) => featureTitle(feature, level)).join(', ') || '—'}
						contentClassName={css.items}
					>
							{rowFeatures.length > 0 && (
								<div>
									<span className={css.columnTitle}>{columnTitle('@Features')}:</span>{' '}
									{humanJoin(
										rowFeatures.map((feature) => (
											<Link
												route={'classFeature'}
												params={{id: heroClass.id, featureId: feature.id}}
												key={feature.id}
											>
												{featureTitle(feature, level)}
											</Link>
										)),
									)}
								</div>
							)}
							{cells.map((cell) => (
								<div key={cell.title}>
									<span className={css.columnTitle}>{cell.title}:</span> {cell.value}
								</div>
							))}
							{slots.length > 0 && (
								<div>
									<span className={css.columnTitle}>Ячейки:</span>{' '}
									<span className={css.slotsWrapper}>
										{slots.map((slot) => (
											<span className={css.slot} key={slot.circle}>
												<span className={css.slotLevel}>{slot.circle}</span>
												<span className={css.slots}>{Array(slot.count).fill('●').join('')}</span>
											</span>
										))}
									</span>
								</div>
							)}
					</AccordionItem>
				);
			})}
		</Accordion>
	);
};
